import { render, staticRenderFns } from "./SvgLiquidLogo.vue?vue&type=template&id=970e8612&"
import script from "./SvgLiquidLogo.vue?vue&type=script&lang=ts&"
export * from "./SvgLiquidLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports